import dcmjs from 'dcmjs';
import { MetadataModules } from '../../enums';
import { addAddProvider, addTypedProvider } from '../../metaData';
import { MetaDataIterator, NaturalTagListener } from '../dicomStream';
import { baseImageIdQueryFilter } from './imageIdsProviders';
const { AsyncDicomReader } = dcmjs.async;
const NATURAL_BASE_IMAGE_ID_FILTER_PRIORITY = 60_000;
const NATURALIZED_ADD_HANDLER_PRIORITY = 30_000;
function toArrayBuffer(part10Value) {
    if (part10Value instanceof ArrayBuffer) {
        return part10Value;
    }
    return part10Value.buffer.slice(part10Value.byteOffset, part10Value.byteOffset + part10Value.byteLength);
}
async function resolvePart10Input(part10) {
    const resolvedValue = typeof part10 === 'function' ? await part10() : part10;
    if (!(resolvedValue instanceof ArrayBuffer) &&
        !(resolvedValue instanceof Uint8Array)) {
        throw new Error('part10 must resolve to ArrayBuffer or Uint8Array');
    }
    return toArrayBuffer(resolvedValue);
}
export function naturalizeDicomwebMetadata(metadata) {
    const iterator = new MetaDataIterator(metadata);
    const listener = NaturalTagListener.createMetadataListener();
    listener.startObject();
    iterator.syncIterator(listener);
    return listener.pop();
}
export async function naturalizePart10Buffer(part10) {
    const arrayBuffer = await resolvePart10Input(part10);
    const reader = new AsyncDicomReader();
    const listener = NaturalTagListener.createMetadataListener();
    reader.stream.addBuffer(arrayBuffer);
    reader.stream.setComplete();
    await reader.readFile({ listener });
    const naturalized = reader.dict;
    const transferSyntaxUid = reader.syntax;
    if (transferSyntaxUid) {
        naturalized.TransferSyntaxUID = Array.isArray(transferSyntaxUid)
            ? transferSyntaxUid[0]
            : transferSyntaxUid;
    }
    return naturalized;
}
function naturalizedAddProvider(next, query, data, options) {
    const dicomwebJson = options?.dicomwebJson ?? options?.metadata;
    if (dicomwebJson && typeof dicomwebJson === 'object') {
        return naturalizeDicomwebMetadata(dicomwebJson);
    }
    const part10Buffer = options?.part10Buffer ?? options?.part10;
    if (part10Buffer) {
        return naturalizePart10Buffer(part10Buffer);
    }
    return next(query, data, options);
}
export function registerNaturalizedHandlers() {
    addTypedProvider(MetadataModules.NATURALIZED, baseImageIdQueryFilter, {
        priority: NATURAL_BASE_IMAGE_ID_FILTER_PRIORITY,
    });
    addAddProvider(MetadataModules.NATURALIZED, baseImageIdQueryFilter, {
        priority: NATURAL_BASE_IMAGE_ID_FILTER_PRIORITY,
    });
    addAddProvider(MetadataModules.NATURALIZED, naturalizedAddProvider, {
        priority: NATURALIZED_ADD_HANDLER_PRIORITY,
    });
}
